import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from './ModalDialog';

import { logoutModalVisibleChanged } from '../../actions';
import { useLogoutSessionCleaner } from '../../hooks';

import logOutImage from '../../assets/log-out.png';

import styles from './LogoutModal.module.css';

/**
 * Logout confirmation modal.
 */
const LogoutModal = () => {
  const { t } = useTranslation('settingsScreen');
  const dispatch = useDispatch();
  const visible = useSelector(({
    common,
  }) => common.logoutModalVisible, shallowEqual);
  const { confirmLogout } = useLogoutSessionCleaner();

  const onCancel = useCallback(() => {
    dispatch(logoutModalVisibleChanged(false));
  }, [dispatch]);

  return (
    <ModalDialog
      cancelable
      hideCloseIcon
      onClose={onCancel}
      show={visible}
    >
      <div className={styles.card}>
        <img alt="" className={styles.icon} src={logOutImage} />

        <p className={styles.message}>
          {t('myAccountMenu.logOutModal.message')}
        </p>

        <div className={styles.actionsContainer}>
          <button
            className={`${styles.actionButton} ${styles.cancelButton}`}
            onClick={onCancel}
            type="button"
          >
            {t('myAccountMenu.logOutModal.cancel')}
          </button>

          <button
            className={`${styles.actionButton} ${styles.logoutButton}`}
            onClick={confirmLogout}
            type="button"
          >
            {t('myAccountMenu.logOutModal.logOut')}
          </button>
        </div>
      </div>
    </ModalDialog>
  );
};

export { LogoutModal };
